enum UserTypesEnum {
    GLOBAL_ADMIN = 1,
    GLOBAL_SUPPORT,
    ADMIN,
    MANAGEMENT,
    SUPPORT,
    SALES,
    INVENTORY_MGMT,
    ORDER_MGMT,
    SHIP_MGMT,
    DRIVER,
}

export default UserTypesEnum;
